import { render, staticRenderFns } from "./Cliente.vue?vue&type=template&id=5048ea66&scoped=true"
import script from "./Cliente.vue?vue&type=script&lang=js"
export * from "./Cliente.vue?vue&type=script&lang=js"
import style0 from "./Cliente.vue?vue&type=style&index=0&id=5048ea66&prod&lang=css"
import style1 from "./Cliente.vue?vue&type=style&index=1&id=5048ea66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5048ea66",
  null
  
)

export default component.exports